import { USER_API } from "@/data/urls";
import axios from "axios";

const api = axios.create({
  baseURL: USER_API,
});

export default api;
